import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { CssBaseline } from '@mui/material';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import CookieConsent from 'react-cookie-consent';
import { useTranslation } from 'react-i18next';
import { useRoutes } from 'react-router-dom';
import useAuth from 'src/hooks/useAuth';
import router from 'src/router';

import AppInit from './components/AppInit';
import { MobileUIBlocker } from './components/MobileUIBlocker';
import ThemeProvider from './theme/ThemeProvider';

const queryClient = new QueryClient();

function App() {
  const content = useRoutes(router);
  const auth = useAuth();
  const { i18n } = useTranslation();
  document.body.dir = i18n.dir();

  return (
    <ThemeProvider>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <CssBaseline />
        <QueryClientProvider client={queryClient}>
          {auth.isInitialized ? (
            <>
              <MobileUIBlocker />
              {content}
            </>
          ) : (
            <AppInit />
          )}
        </QueryClientProvider>
        <CookieConsent
          location="bottom"
          cookieName="CapturAcceptConsent"
          expires={999}
          style={{
            alignItems: 'center',
            flexDirection: 'column',
            padding: '16px'
          }}
          contentStyle={{
            flex: '1 0 30px'
          }}
          buttonStyle={{
            padding: '8px 16px 8px 16px',
            borderRadius: '8px'
          }}
        >
          This website uses cookies to enhance the user experience.
        </CookieConsent>
      </LocalizationProvider>
    </ThemeProvider>
  );
}
export default App;
